import fetch from '@/utils/fetch'

// =================== 群体分析 ===================
export function groupIntraAnalysis(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/groupIntraAnalysis/groupIntraAnalysis',
    method: 'post',
    data: {
      ...param
    }
  })
}

// 评估阶段 ---  年 - 上下学期 - 学期初中末
export function customGroupPlanList2(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/customGroup/planList',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 身高

export function heightDistribute(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/groupIntraAnalysis/heightDistribute',
    method: 'post',
    data: {
      ...param
    }
  })
}
// BMI

export function BMIDistribute(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/groupIntraAnalysis/BMIDistribute',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 均分
export function synthEZAvgScore(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/groupIntraAnalysis/synthEZAvgScore',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 均分 -- 子能区
export function childEZAvgScore(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/groupIntraAnalysis/childEZAvgScore',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 分布占比 -- 状态分布
export function synthEZDistributeScoreType(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/groupIntraAnalysis/synthEZDistributeScoreType',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 分布占比 -- 十分
export function synthEZDistributeTenGear(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/groupIntraAnalysis/synthEZDistributeTenGear',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 分布占比 -- 得分
export function evaluationRecordDataSyncVoPageVo(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/groupIntraAnalysis/evaluationRecordDataSyncVoPageVo',
    method: 'post',
    data: {
      ...param
    }
  })
}

// =================== 群体对比 ===================

// 首页
export function groupBetweenCompare(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/groupBetweenCompare/groupBetweenCompare',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 群体对比-班级列表
export function groupCompareClassList(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/groupBetweenCompare/classrooms',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 群体对比-群组列表
export function groupCompareGroupList(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/groupBetweenCompare/list',
    method: 'post',
    data: {
      ...param
    }
  })
}

// 身高
export function groupCompareHeightDistribute(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/groupBetweenCompare/heightDistribute',
    method: 'post',
    data: {
      ...param
    }
  })
}
// BMI
export function groupCompareBMIDistribute(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/groupBetweenCompare/BMIDistribute',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 均分
export function groupCompareSynthEZAvgScore(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/groupBetweenCompare/synthEZAvgScore',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 状态分布
export function groupCompareSynthEZDistributeScoreType(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/groupBetweenCompare/synthEZDistributeScoreType',
    method: 'post',
    data: {
      ...param
    }
  })
}

// 身高(班级对比)
export function groupCompareHeightDistributeForClass(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/groupBetweenCompare/heightDistribute',
    method: 'post',
    data: {
      ...param
    }
  })
}
// BMI(班级对比)
export function groupCompareBMIDistributeForClass(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/groupBetweenCompare/BMIDistribute',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 均分(班级对比)
export function groupCompareSynthEZAvgScoreForClass(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/groupBetweenCompare/synthEZAvgScore',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 状态分布(班级对比)
export function groupCompareSynthEZDistributeScoreTypeForClass(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/groupBetweenCompare/synthEZDistributeScoreType',
    method: 'post',
    data: {
      ...param
    }
  })
}

// ================== 自定义群组 ===================

// 新增
export function customGroupAdd(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/customGroup/add',
    method: 'post',
    data: {
      ...param
    }
  })
}

// 编辑
export function customGroupEdit(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/customGroup/edit',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 详情
export function customGroupInfo(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/customGroup/info',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 详情
export function customGroupDel(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/customGroup/delete',
    method: 'post',
    data: {
      ...param
    }
  })
}

// 评估计划列表
export function customGroupPlanList(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/customGroup/planList',
    method: 'post',
    data: {
      ...param
    }
  })
}

// ================== 评测统计最新 ===================
export function getClassList(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/groupIntraAnalysis/classroomTypeTree',
    method: 'post',
    data: {
      ...param
    }
  })
}
// ================== 趋势分析 ===================
// web端_群组对比_BMI分布页面数据
export function groupTrendBMIDistribute(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/group/trend/BMIDistribute',
    method: 'post',
    data: {
      ...param
    }
  })
}
// web端_群组对比_班级对比_BMI分布_详细数据页面
export function groupTrendBMIDistributeForDetailData(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/group/trend/BMIDistributeForDetailData',
    method: 'post',
    data: {
      ...param
    }
  })
}
// web端_群体对比页面
export function groupTrendGroupBetweenCompare(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/group/trend/groupBetweenCompare',
    method: 'post',
    data: {
      ...param
    }
  })
}
// web端_群体对比页面
export function groupTrendSynthEZAvgScore(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/group/trend/synthEZAvgScore',
    method: 'post',
    data: {
      ...param
    }
  })
}
// web端_群体对比页面
export function groupTrendSynthEZDistributeScoreType(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/group/trend/synthEZDistributeScoreType',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 获得测评计划树
export function getSemesterPeriodComboVoList(param:any) {
  return fetch({
    url: '/api-evaluation/organize/web/groupIntraAnalysis/semesterPeriodComboVoList',
    method: 'post',
    data: {
      ...param
    }
  })
}
